// src/pages/admin/sessions/SessionsList.jsx
import React from "react";
import { useParams } from "react-router-dom";
import SessionsList from "../../../components/attendance/SessionsList";

const AdminSessionsList = () => {
    const { id } = useParams(); // present when routed via /admin/batches/:id/sessions
    const initialBatchId = id ? Number(id) : undefined;
    return <SessionsList role="ADMIN" initialBatchId={initialBatchId} />;
};

export default AdminSessionsList;
